const InfoButton = ({ buttonText, onClick, type }) => {
    return (
        <button className={`${type === "primary" ? "bg-sky-500 text-white hover:bg-sky-600" : "bg-transparent hover:bg-sky-500 text-sky-700 hover:text-white border-sky-500 hover:border-transparent"} font-semibold rounded border py-2 px-4`} onClick={onClick}>
            {buttonText}
        </button>
    );
}

export default InfoButton;